import { useQuery } from '@tanstack/react-query';
import { ApiError, ICity } from 'utils/types';
import axios from 'axios';

import c from '../utils/constants';

interface Result {
  data: ICity[];
}

export default function useGetCities(params: {
  countryCode: string;
  isoCode: string;
  keyword?: string;
}) {
  return useQuery<ICity[], ApiError>({
    queryKey: [c.CITIES, params],
    queryFn: async () => {
      const { countryCode, isoCode, ...rest } = params;

      const result = await axios.get<Result>(
        // eslint-disable-next-line max-len
        `${import.meta.env.VITE_APP_END_POINT}/api/v1/common/countries/${countryCode}/states/${isoCode}/cities`,
        {
          params: rest,
          headers: {
            Authorization: import.meta.env.VITE_APP_BASIC_AUTH,
          },
        },
      );

      return result.data?.data;
    },
    enabled: !!params.countryCode && !!params.isoCode,
  });
}
